import React from 'react';
import { RouteComponentProps } from 'react-router';
import Locale from 'localization/Localization';
import { ResetForm } from 'components/login/ResetForm';
import { ResetPasswordForm } from 'components/login/ResetPasswordForm';
import { PublicLayout } from 'components/public/PublicLayout';

interface RouteParams {
	token: string;
	region: string;
}

interface ResetPageState {
	token: string | undefined;
}

export class ResetPage extends React.Component<RouteComponentProps<RouteParams>, ResetPageState>
{
	constructor(props: RouteComponentProps<RouteParams>) {
		super(props);

		this.state = {
			token: this.props.match.params.token
		};
	}

	public componentDidMount() {
		document.title = Locale.getPageTitle('page_reset');
	}

	public render() {
		if (this.state.token) {
			return (
				<PublicLayout>
					<ResetPasswordForm token={this.state.token} />
				</PublicLayout>
			);
		}
		else {
			return (
				<PublicLayout>
					<ResetForm />
				</PublicLayout>
			);
		}
	}
}